import React, {VoidFunctionComponent} from 'react';

import styles from './checkbox.module.css';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  onChange: () => void;
  value: string;
  label: string;
  name: string;
  checked: boolean;
}

const Checkbox: VoidFunctionComponent<Props> = props => {
  const {onChange, className, label, value, name, checked, ...rest} = props;

  return (
    <label htmlFor={`checkbox-${value}`} className={styles.checkbox}>
      <input
        id={`checkbox-${value}`}
        type="checkbox"
        value={value}
        name={name}
        checked={checked}
        onChange={onChange}
        className={className}
        {...rest}
      />
      <span className={styles.checkMark}></span>
      <span className={styles.labelTitle}>{label}</span>
    </label>
  );
};
export default Checkbox;
